import { useGetTicketByIdQuery, useGetTicketHistoryQuery } from "../../api/ticketApi/ticket";
import { useParams } from "react-router";
import TicketTable from "../../components/Table";
import { Breadcrumb, Card, Tabs, Spinner } from "flowbite-react";
import NavbarSidebarLayout from "../../layouts/navbar-sidebar";
import { HiHome } from "react-icons/hi";
import TicketNotes from "./ticketNote";
import { QueryParams } from "@/sharedTypes";
import { useState } from "react";
import TicketDetailsInfo from "../../components/ticketDetails/TicketDetailsInfo";
import UseErrorHandler from "@/components/UseErrorHandler";
import TicketMailTab from "./TicketMailPanel";
import { useTranslation } from "react-i18next";

function TicketDetails() {
  const params = useParams();
  const ticketId = params?.ticketId;
  const { t } = useTranslation("common");

  const [queryParams, setQueryParams] = useState<QueryParams>({
    filters: {},
    pagination: {
      pageSize: 15,
      page: 1,
    },
  });

  const {
    data: historyData,
    isError: isHistoryError,
    error: historyError,
    isLoading: isHistoryLoading,
  } = useGetTicketHistoryQuery({
    ticketId: ticketId as string,
    queryParams,
  });

  const {
    data: ticket,
  } = useGetTicketByIdQuery(ticketId as string);

  console.log("Ticket data:", ticket);

  UseErrorHandler({
    title: "Failed to load ticket history",
    isError: isHistoryError,
    error: historyError,
  });

  //History data
  const historyColumns = [
    { key: "ticket_ref", label: "Ticket Ref" },
    { key: "ticket_title", label: "Title" },
    { key: "ticket_description", label: "Description" },
    { key: "status", label: "Status" },
    { key: "priority", label: "Priority" },
    { key: "assigned_agent", label: "Assigned Agent" },
    { key: "update_reason", label: "Update Reason" },
    { key: "createdAt", label: "Created At" },
  ];

  const formattedHistoryData =
    historyData?.items.map((ticket: any) => ({
      ticket_id: ticket.ticket_id,
      ticket_title: ticket.ticket_title,
      ticket_description: ticket.ticket_description,
      status: ticket.history_status?.status_name || "N/A",
      priority: ticket.ticket_priority?.priority_name || "N/A",

      assigned_agent: ticket.assigned_agent?.agent_username || "Unassigned",
      update_reason: ticket.update_reason?.update_reason_description || "N/A",
      createdAt: new Date(ticket.createdAt).toLocaleString(),
      updatedAt: new Date(ticket.updatedAt).toLocaleString(),
    })) || [];

  const handlePaginationChange = (newPageIndex: number) => {
    setQueryParams((prev) => ({
      ...prev,
      pagination: {
        ...prev.pagination,
        page: newPageIndex,
      },
    }));
  };

  return (
    <NavbarSidebarLayout>
      <div className="h-screen overflow-y-auto pb-20">
        <div className="mb-6 grid grid-cols-1 gap-y-6 px-4 pt-6 dark:border-gray-700 dark:bg-gray-900">
          <div className="col-span-full">
            <Breadcrumb className="mb-4">
              <Breadcrumb.Item href="/">
                <div className="flex items-center gap-x-3">
                  <HiHome className="text-xl" />
                  <span className="dark:text-white">{t("home")}</span>
                </div>
              </Breadcrumb.Item>

              <Breadcrumb.Item>{t("ticketDetails")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
        {/* Ticket Details section */}

        <Card className="m-4 overflow-x-auto">
          <Tabs aria-label="Ticket Details Tabs" className="borde-0">
            <Tabs.Item title="Ticket Details">
              <TicketDetailsInfo ticketId={ticketId as string} />
            </Tabs.Item>
            <Tabs.Item title="Ticket History">
              {isHistoryLoading ? (
                <div className="flex w-full items-center justify-center">
                  <Spinner size="lg" />
                </div>
              ) : (
                <TicketTable
                  columns={historyColumns}
                  data={formattedHistoryData}
                  pagination={historyData?.pagination}
                  onPageChange={handlePaginationChange}
                />
              )}
            </Tabs.Item>
            <Tabs.Item title="Notes">
              <TicketNotes ticketId={ticketId as string} />
            </Tabs.Item>

            <Tabs.Item title="Mails">
              <TicketMailTab
                ticketId={ticketId as string}
                currentAgentName={ticket?.last_assigned_agent?.agent_username || "Agent"}
              />
            </Tabs.Item>
          </Tabs>
        </Card>
      </div>
    </NavbarSidebarLayout>
  );
}

export default TicketDetails;
